import React, { createContext, useContext } from 'react';
import type { Store } from '@/stores';

const StoreContext = createContext({} as Store);

export function StoreProvider({ store, children }) {
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}

export function useStore(): Store {
  return useContext<Store>(StoreContext);
}

export default StoreContext;
